import React from 'react';
import CandidateDetails from '../../Home/Candidates/CandidateDetails';

const AgencyAppliedCandidatesView = () => {
  return <CandidateDetails />;
};

export default AgencyAppliedCandidatesView;
